







import { Component, Vue, Prop } from 'vue-property-decorator';
import * as calc from '@/app/order-calculations-interface';
import { GQL_order_order } from '@/queries/__generated__/order';
import DocumentSummary from '../Shared/DocumentSummary.vue';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';

@Component({
  components: {
    DocumentSummary,
  },
})
export default class OrderSummary extends Vue {
  @Prop(Object) public order!: GQL_order_order;

  public taxSubtotals: calc.IOrderTaxSubtotal[] = [];

  public created() {
    this.calculate();
  }

  @WatchObjectAsJson('order')
  public calculate() {
    const order = this.order as unknown as calc.IOrder;
    this.order.lineExtensionAmount = calc.orderLineExtensionAmount(order);
    this.order.taxExclusiveAmount = calc.orderTaxExclusiveAmount(order);
    this.taxSubtotals = calc
      .orderTaxSubtotals(order)
      .sort((a, b) => a.taxPercent.sub(b.taxPercent).toNumber());
    this.order.taxAmount = calc.orderTaxAmount(this.taxSubtotals);
    this.order.taxInclusiveAmount = calc.orderTaxInclusiveAmount(order);
    this.order.payableAmount = calc.orderPayableAmount(order);
  }
}
